/**
 * EVO — 404.
 *
 * ============================================================================
 * BOSHI BERK KO'CHA BO'LMASLIGI KERAK
 * ============================================================================
 * Bu ekranga tasodifan kelinmaydi: odatda eski xatcho'p, hamkasb yuborgan
 * havola yoki o'chirilgan hujjatning manzili. Ya'ni foydalanuvchining biror
 * NIYATI bor edi va u bajarilmadi — unga faqat «bunday sahifa yo'q» deb
 * qo'yish ishni to'xtatadi.
 *
 * Shuning uchun ikkita chiqish yo'li va ular AR HIL: «Orqaga» avvalgi ekranga
 * qaytaradi (havola noto'g'ri bo'lsa xodim ishini davom ettiradi), «Bosh
 * sahifa» esa yangi boshlanish nuqtasi (xatcho'p eskirgan bo'lsa orqaga
 * qaytish yordam bermaydi — u yana o'sha yo'q manzilga olib borishi mumkin).
 *
 * Ikkalasi ham TUGMA ko'rinishida: matnli havola telefonda barmoq bilan
 * bosish uchun juda kichik, bu ekran esa ombordan ham ochiladi.
 */
import type { ReactNode } from 'react';
import { Link, useRouter } from '@tanstack/react-router';
import { useT } from '../lib/i18n-context';
import { Button } from '../components/ui/button';

export function NotFoundPage(): ReactNode {
  const t = useT();
  const router = useRouter();

  return (
    <div className="flex min-h-64 flex-col items-center justify-center gap-3 p-8 text-center">
      <p className="evo-num text-3xl font-semibold text-ink-muted">404</p>
      <p className="text-sm text-ink">{t('error.pageNotFound')}</p>

      <div className="flex flex-wrap items-center justify-center gap-2">
        <Button variant="secondary" onClick={() => router.history.back()}>
          {t('common.back')}
        </Button>
        {/* `<Link>` tugma ko'rinishida, `<Button onClick={navigate}>` emas:
            o'rta tugma bilan yangi oynada ochish va manzilni nusxalash
            ishlashda qolishi kerak — ular haqiqiy `<a>` ni talab qiladi. */}
        <Link
          to="/"
          className="inline-flex h-10 items-center justify-center rounded-md border border-transparent bg-brand px-4 text-sm font-medium text-brand-ink hover:opacity-90"
        >
          {t('nav.dashboard')}
        </Link>
      </div>
    </div>
  );
}
